import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Blog from "./pages/Blog";
import PostView from "./pages/PostView";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Editor from "./pages/admin/Editor";
import { ADMIN_PATH } from "./config";

const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);

const LocalhostOnly = ({ children }: { children: React.ReactNode }) => {
    return isLocalhost ? <>{children}</> : <Navigate to="/" replace />;
};

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const token = localStorage.getItem("token");
    return token ? <>{children}</> : <Navigate to={`${ADMIN_PATH}/login`} replace />;
};

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Blog />} />
            <Route path="/post/:slug" element={<PostView />} />
            <Route path={`${ADMIN_PATH}/login`} element={<LocalhostOnly><Login /></LocalhostOnly>} />
            <Route path={ADMIN_PATH} element={<LocalhostOnly><ProtectedRoute><Dashboard /></ProtectedRoute></LocalhostOnly>} />
            <Route path={`${ADMIN_PATH}/new`} element={<LocalhostOnly><ProtectedRoute><Editor /></ProtectedRoute></LocalhostOnly>} />
            <Route path={`${ADMIN_PATH}/edit/:id`} element={<LocalhostOnly><ProtectedRoute><Editor /></ProtectedRoute></LocalhostOnly>} />
        </Routes>
    </BrowserRouter>
);

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
